import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Subtle, professional fade-up used for scroll reveals across sections.
export function Reveal({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

// Masked, line-by-line headline reveal for the signature hero moment.
export function MaskedLines({ lines, ariaLabel, className = "", lineClassName = "", startDelay = 0.15 }) {
  return (
    <span className={`block ${className}`} aria-label={ariaLabel || lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden" aria-hidden="true">
          <motion.span
            className={`block pb-[0.12em] ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: EASE, delay: startDelay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
